import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "emailWrap", "email"]

  connect() {
    this.applyVisibility()
  }

  toggle() {
    this.applyVisibility()

    if (this.checkboxTarget.checked) {
      setTimeout(() => this.emailTarget.focus(), 0)
    }
  }

  applyVisibility() {
    const show = this.checkboxTarget.checked
    this.emailWrapTarget.classList.toggle("hidden", !show)

    if (!show) {
      this.emailTarget.value = ""
    }
  }
}
